import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Kpi = _resolveComponent("Kpi")
  const _component_Tracker = _resolveComponent("Tracker")
  const _component_OrgMap = _resolveComponent("OrgMap")

  return (_openBlock(), _createElementBlock("div", {
    ref: "element",
    class: _normalizeClass(["widget", ['widget-' + $options.widget_type, {snapshot: $props.snapshot && $options.widget_type === 'card'}]])
  }, [
    ($options.widget_type === 'card')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Ellipsis, { class: "title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.widget.title), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Kpi, {
            ref: "kpi",
            widget: $props.widget,
            snapshot: $props.snapshot
          }, null, 8 /* PROPS */, ["widget", "snapshot"]),
          ($props.widget.explanation)
            ? (_openBlock(), _createBlock(_component_Ellipsis, {
                key: 0,
                class: "explanation"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.widget.explanation), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : ($props.widget.type.startsWith('tracker_'))
        ? (_openBlock(), _createBlock(_component_Tracker, {
            key: 1,
            widget: $props.widget
          }, null, 8 /* PROPS */, ["widget"]))
        : ($props.widget.type === 'orgmap')
          ? (_openBlock(), _createBlock(_component_OrgMap, {
              key: 2,
              widget: $props.widget
            }, null, 8 /* PROPS */, ["widget"]))
          : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}